import { Injectable } from '@angular/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

@Injectable({ providedIn: 'root' })
export class CapgoReadyService {
  private fired = false;

  /**
   * Notify Capgo that app is ready.
   *
   * This tells Capgo:
   * 1. Current update is stable (don't rollback)
   * 2. Start checking for new updates
   *
   * Safe to call immediately because:
   * - directUpdate: 'onLaunch' ensures updates only apply between sessions (not mid-session)
   * - Background token refresh keeps tokens fresh (every 30 mins)
   * - Cold start syncs from Keychain/native storage
   * - No risk of mid-session reload interrupting user
   */
  async notifyOnce() {
    if (this.fired) return;

    this.fired = true;

    try {
      await CapacitorUpdater.notifyAppReady();
    } catch (error) {
      console.error('[Capgo] Failed to notify Capgo:', error);
      // Don't re-throw - app should continue even if Capgo notification fails
    }
  }

  /**
   * Reset state (for testing/debugging)
   */
  reset() {
    this.fired = false;
  }
}
